import React from 'react';

export default function CompletedIcon({
  width = 48,
  height = 48,
  fill = '#9F9FA0',
  className,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
  fill?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_10015_20233)">
        <path
          d="M22.4079 47.9785C11.9888 47.3485 2.88593 39.5024 0.59407 29.3639C-2.2555 16.7571 5.41262 4.0564 17.8875 0.816125C19.6194 0.36563 22.4771 -0.148216 24.236 0.0406637C26.2531 0.256526 26.4809 3.46513 23.953 3.69155C19.6475 4.07517 16.9236 4.41422 13.1723 6.78049C0.91108 14.514 0.380381 32.1854 12.2154 40.6028C23.7534 48.8091 40.0747 42.8682 43.6804 29.2923C44.1982 27.3449 44.1489 25.8925 44.3555 23.9744C44.5892 21.8005 47.2509 21.5987 48 23.5415V25.6016L47.6912 27.962C46.0451 37.9573 37.959 46.0228 27.9579 47.6711L25.5944 47.9797C24.5448 47.9327 23.4505 48.043 22.4067 47.9797L22.4079 47.9785Z"
          fill={fill}
        />
        <path
          d="M22.2317 28.1171C22.3304 28.1746 22.4713 28.1171 22.5523 28.0409L43.968 6.64001C45.7222 5.02339 48.1432 7.07642 46.7366 9.03091L23.7698 31.971C22.9174 32.8121 21.8501 32.8825 20.9555 32.0613C18.1799 28.7999 15.0391 25.8377 12.2354 22.6068C11.7657 22.0648 11.417 21.7034 11.4017 20.9327C11.37 19.302 13.386 18.5359 14.5237 19.6656C17.0527 22.3827 19.5043 25.1783 22.085 27.8473C22.1589 27.9235 22.2165 28.1077 22.2317 28.1171Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_10015_20233">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
